import {
  clearSession,
  getSessionBoolean,
  getSessionString,
  getSessionToken,
  setSessionDetails,
} from "../utils/session";

export const setLogInData = (
  username,
  userId,
  profilerUrl,
  ibmRestricted,
  xtvmAllowed,
  altDataAllowed,
  ibmAllowed
) => {
  setSessionDetails({
    user: username,
    userId,
    profilerUrl,
    ibmRestricted,
    xtvmAllowed,
    altDataAllowed,
    ibmAllowed,
  });
}

export function getToken() {
  return getSessionToken();
}
export function getUser() { return getSessionString("user") }
export function getUserId() { return getSessionString("userId") }

export function getProfilerUrlReady() {
  return getSessionBoolean("profilerUrlReady");
}
export function getAuthorizationHeader() {
  return {"headers": {"Authorization": "Bearer " + getToken()}};
}

export function isAuth() {
  const url = window.location.href;

  if (url.includes("/auth/")) {
    const username = url.split('/auth/')[1].split('/')[0];

    const password = url.split('/auth/')[1].split('/')[1];

    const rawProfilerUrl = process.env.REACT_APP_PROFILER_URL || 'https://3di-profiler.net/authServlet?username=[username]&password=[password]&redirect=[redirectid]';
    const profilerUrl = rawProfilerUrl
        .replace('[username]', encodeURIComponent(username))
        .replace('[password]', encodeURIComponent(password));

    localStorage.setItem("profilerUrlReady", "true");
    localStorage.setItem("profilerUrl", profilerUrl);

    return true;
  }

  return false;
}

export function clearLogInData() {
  clearSession();
}
